module.exports = "/_next/static/images/28-1-1e8143b60b1fa5ca80a199913642dd71.jpg";